export const cleanupStep5 = (data) => {
  const cleanedData = { ...data };
  

  
  return cleanedData;
};